<template>
  <el-table
    :data="items"
    v-loading="loading"
    border
    style="width: 100%"
    cell-class-name="table-small-cell"
  >
    <el-table-column
      align="center"
      prop="user_name"
      min-width="90"
      label="创建人"
    ></el-table-column>
    <el-table-column
      align="center"
      prop="created_at"
      min-width="96"
      label="下单日期"
    >
      <template slot-scope="scope">
        {{ $time(scope.row.created_at).format('YYYY-MM-DD') }}
      </template>
    </el-table-column>
    <el-table-column
      align="center"
      prop="drill_type_name"
      min-width="80"
      label="钻头"
    ></el-table-column>
    <el-table-column
      align="center"
      prop="fix_base_name"
      min-width="80"
      label="维修基地"
    ></el-table-column>
    <el-table-column
      align="center"
      prop="drill_size"
      min-width="90"
      label="规格"
    ></el-table-column>
    <el-table-column
      align="center"
      prop="model_number"
      min-width="120"
      label="型号"
    ></el-table-column>
    <el-table-column
      align="center"
      prop="component_number"
      min-width="100"
      label="零件号"
    ></el-table-column>
    <el-table-column
      align="center"
      prop="drill_number"
      min-width="80"
      label="总 / 到达"
    >
      <template slot-scope="scope">
        {{ scope.row.drill_number }} / {{ scope.row.drill_receive_number }}
      </template>
    </el-table-column>
    <el-table-column
      align="center"
      prop="block_info"
      min-width="120"
      label="使用区块"
    ></el-table-column>
    <el-table-column
      align="center"
      prop="cut_info"
      min-width="100"
      label="下料"
    ></el-table-column>
    <el-table-column
      align="center"
      prop="old_drill_serial_number"
      min-width="120"
      label="旧序列号"
    >
      <template slot-scope="scope">
        <DrillLink
          :no="scope.row.old_drill_serial_number"
          v-if="scope.row.is_drill_new == 2"
        ></DrillLink>
      </template>
    </el-table-column>
    <el-table-column
      align="center"
      prop="old_drill_serial_number"
      min-width="100"
      label="序列号"
    >
      <template slot-scope="scope">
        <DrillLink
          v-for="drill in scope.row.drills"
          :key="drill.serial_number"
          :no="drill.serial_number"
          >{{ drill.serial_number }}</DrillLink
        >
      </template>
    </el-table-column>
    <el-table-column
      align="center"
      prop="deliver_time"
      min-width="96"
      label="交货时间"
    >
      <template slot-scope="scope">
        {{ scope.row.deliver_time ? scope.row.deliver_time : '-' }}
      </template>
    </el-table-column>
    <el-table-column
      align="center"
      prop="sale_type_info"
      min-width="80"
      label="销售类型"
    ></el-table-column>
    <el-table-column
      align="center"
      prop="welding_rod"
      min-width="80"
      label="敷焊条"
    ></el-table-column>
    <el-table-column
      align="center"
      prop="nozzle_install_info"
      min-width="80"
      label="安装方式"
    ></el-table-column>
    <el-table-column
      align="center"
      prop="nozzle"
      min-width="100"
      label="喷嘴"
    ></el-table-column>
    <el-table-column
      align="center"
      prop="package_type_info"
      min-width="80"
      label="包装"
    ></el-table-column>
    <el-table-column
      align="center"
      prop="remark"
      min-width="90"
      label="备注"
    ></el-table-column>
    <el-table-column
      align="center"
      prop="status_name"
      width="100"
      label="进度"
    ></el-table-column>
    <el-table-column
      align="center"
      prop="option_status_name"
      width="80"
      label="状态"
    ></el-table-column>

    <el-table-column
      align="center"
      fixed="right"
      label="操作"
      :width="
        orderModule == 'orders' || orderModule == 'orders_pause' ? 172 : 110
      "
      class-name="option-flex"
    >
      <template slot-scope="scope">
        <btn-tag
          :href="`/orders/${scope.row.id}`"
          text="详情"
          :key="Math.random()"
          :auth-id="32101"
          module-name="orders"
          v-if="orderModule == 'orders'"
        ></btn-tag>
        <btn-tag
          :href="`/orders/ongoing/${scope.row.id}`"
          text="详情"
          :key="Math.random()"
          :auth-id="32101"
          module-name="orders"
          v-if="orderModule == 'orders_ongoing'"
        ></btn-tag>
        <btn-tag
          :href="`/orders/archive/${scope.row.id}`"
          text="详情"
          :key="Math.random()"
          :auth-id="32101"
          module-name="orders"
          v-if="orderModule == 'orders_archive'"
        ></btn-tag>
        <btn-tag
          :href="`/orders/pause/${scope.row.id}`"
          text="详情"
          :key="Math.random()"
          :auth-id="32101"
          module-name="orders"
          v-if="orderModule == 'orders_pause'"
        ></btn-tag>
        <btn-tag
          :href="`/orders/close/${scope.row.id}`"
          text="详情"
          :key="Math.random()"
          :auth-id="32101"
          module-name="orders"
          v-if="orderModule == 'orders_close'"
        ></btn-tag>
        <template v-if="scope.row.option_status == 1">
          <btn-tag
            :href="'/orders/' + scope.row.id + '/edit'"
            text="编辑"
            :key="Math.random()"
            :auth-id="32102"
            module-name="orders"
            v-if="scope.row.status < 2 || scope.row.status == 7"
          ></btn-tag>
          <btn-tag
            :href="'/orders/archive/' + scope.row.id + '/edit'"
            text="编辑"
            :key="Math.random()"
            :auth-id="32102"
            module-name="orders"
            v-if="scope.row.status == 6"
          ></btn-tag>
          <btn-tag
            :btn="true"
            text="负责人审核"
            :key="Math.random()"
            btn-class="btn-info"
            :auth-id="32109"
            module-name="orders"
            @click.native="hanldeUpdate(scope.row, scope.$index, 7)"
            v-if="
              scope.row.status == 1 &&
              scope.row.principals.includes(userInfo.id)
            "
          ></btn-tag>
          <btn-tag
            :btn="true"
            text="技术确认"
            :key="Math.random()"
            :auth-id="32103"
            btn-class="btn-info"
            module-name="orders"
            @click.native="hanldeUpdate(scope.row, scope.$index, 2)"
            v-if="scope.row.status == 7"
          ></btn-tag>
          <btn-tag
            :btn="true"
            text="领导审批"
            :key="Math.random()"
            :auth-id="32104"
            btn-class="btn-info"
            module-name="orders"
            @click.native="hanldeUpdate(scope.row, scope.$index, 3)"
            v-if="scope.row.status == 2"
          ></btn-tag>
          <btn-tag
            :href="'/orders/' + scope.row.id + '/factory'"
            text="填写外协商厂家"
            :key="Math.random()"
            :auth-id="32105"
            btn-class="btn-info"
            module-name="orders"
            v-if="scope.row.status == 3"
          ></btn-tag>
          <btn-tag
            :btn="true"
            text="模型发送确认"
            :key="Math.random()"
            :auth-id="32107"
            btn-class="btn-info"
            module-name="orders"
            @click.native="hanldeUpdate(scope.row, scope.$index, 4)"
            v-if="
              scope.row.status == 4 &&
              scope.row.principals.includes(userInfo.id)
            "
          ></btn-tag>
        </template>
        <template v-if="scope.row.status != 6">
          <btn-tag
            :btn="true"
            text="暂停"
            :key="Math.random()"
            :auth-id="32102"
            btn-class="btn-warning"
            module-name="orders"
            @click.native="hanldeUpdateOptionStatus(scope.row, scope.$index, 2)"
            v-if="scope.row.option_status == 1"
          ></btn-tag>

          <btn-tag
            :btn="true"
            text="恢复"
            :key="Math.random()"
            :auth-id="32102"
            btn-class="btn-warning"
            module-name="orders"
            @click.native="hanldeUpdateOptionStatus(scope.row, scope.$index, 1)"
            v-if="scope.row.option_status == 2"
          ></btn-tag>
        </template>
        <btn-tag
          :btn="true"
          text="关闭"
          :key="Math.random()"
          :auth-id="32102"
          btn-class="btn-danger"
          module-name="orders"
          @click.native="hanldeUpdateOptionStatus(scope.row, scope.$index, 3)"
          v-if="scope.row.option_status != 3 && scope.row.status != 6"
        ></btn-tag>
      </template>
    </el-table-column>
  </el-table>
</template>

<script>
import {
  orderDelete,
  orderLaunch,
  orderCheck,
  orderApprove,
  orderFactory,
  orderModelSendCheck,
  orderUpdateOptionStatus,
  orderChiefCheck,
} from '@/service/getData'
import { getStore } from '@/config/mUtils'

export default {
  props: {
    loading: {
      type: Boolean,
      default: false,
    },
    items: null,
  },
  data() {
    return {
      userInfo: getStore('userInfo'),
      orderModule: this.$route.meta.en_name,
    }
  },
  watch: {
    $route: function () {
      this.orderModule = this.$route.meta.en_name
    },
  },
  created() {},
  methods: {
    hanldeUpdate(item, index, status) {
      let that = this
      let data = { id: item.id }
      var confirmText = status == 4 ? '确认已发送模型吗？' : '确认审核通过吗？'
      var cancelText = status == 4 ? '取消' : '打回'
      that.$dialog
        .confirm(confirmText, {
          cancelText: cancelText,
        })
        .then(function (dialog) {
          data.pass = true
          switch (status) {
            case 1:
              orderLaunch(data).then((res) => {
                if (res.status == 0) {
                  that.$set(that.items, index, res.data)
                }
              })
              break
            case 7:
              orderChiefCheck(data).then((res) => {
                if (res.status == 0) {
                  that.$set(that.items, index, res.data)
                }
              })
              break
            case 2:
              orderCheck(data).then((res) => {
                if (res.status == 0) {
                  that.$set(that.items, index, res.data)
                }
              })
              break
            case 3:
              orderApprove(data).then((res) => {
                if (res.status == 0) {
                  that.$set(that.items, index, res.data)
                }
              })
              break
            case 4:
              orderModelSendCheck(data).then((res) => {
                if (res.status == 0) {
                  that.$set(that.items, index, res.data)
                }
              })
          }
        })
        .catch(function () {
          data.pass = false
          switch (status) {
            case 7:
              orderChiefCheck(data).then((res) => {
                if (res.status == 0) {
                  that.$dialog.alert('打回成功')
                  that.items.splice(index, 1)
                }
              })
              break
            case 2:
              orderCheck(data).then((res) => {
                if (res.status == 0) {
                  that.$dialog.alert('打回成功')
                  that.items.splice(index, 1)
                }
              })
              break
            case 3:
              orderApprove(data).then((res) => {
                if (res.status == 0) {
                  that.$dialog.alert('打回成功')
                  that.$set(that.items, index, res.data)
                }
              })
              break
          }
        })
    },
    hanldeUpdateOptionStatus(item, index, status) {
      let that = this
      let data = { id: item.id, option_status: status }
      var confirmText = '确认暂停订单吗？'
      if (status == 1) {
        confirmText = '确认恢复订单吗？'
      } else if (status == 3) {
        confirmText = '确认关闭订单吗？'
      }
      that.$dialog.confirm(confirmText).then(async function (dialog) {
        let res = await orderUpdateOptionStatus(data)
        if (res.status == 0) {
          that.$set(that.items, index, res.data)
        }
      })
    },
    hanldeDelte(item, index) {
      let that = this
      that.$dialog.confirm('确认删除吗').then(function (dialog) {
        orderDelete(item.id).then((res) => {
          if (res.status == 0) {
            that.items.splice(index, 1)
          }
        })
      })
    },
  },
}
</script>

<style scoped>
.alink {
  display: block;
}
</style>
<style >
td.option-flex .cell {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  align-items: center;
}
</style>